import { useState, useEffect, useRef } from "react";
import ActionsDataTable from "../../shared/DataTable/ActionsDataTable";
import { companyActions } from "../../redux/actions/company.actions";
import { useDispatch, useSelector } from "react-redux";
import { globalConstants, modeConstants } from "../../constants";
import { useNavigate } from "react-router-dom";
import { projectActions, recruiterActions } from "../../redux/actions";
import PlatformModal from "./Modal/PlatformModal";
export default function Platform() {
  const initialGridState = {
    length: 10,
    pageNumber: 1,
    orderBy: "",
    filterQuery: null,
    search: null,
    filterExpression: globalConstants.FILTER_EXPRESSION,
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const sortingInProgressRef = useRef(false);
  const [showModal, setShowModal] = useState(false);
  const [gridState, setGridState] = useState(initialGridState);
  const [defaultPage, setDefaultPage] = useState(initialGridState.pageNumber);
  const [mode, setMode] = useState(modeConstants.ADD_MODE);
  const [rowData, setRowData] = useState({ items: [], total: 0 });
  const allData = useSelector((s) => s.companyReducer.data);

  const filterColumns = [
    { key: "companyName", label: "Company Name", type: "string" },
  ];

  const columns = [
    {
      name: "Sr. No",
      selector: (row, index) => index + 1, // start from 1
      sortable: false,
      width: "100px",
    },
    {
      id: "companyName",
      name: "Name",
      selector: (r) => r.companyName,
      sortable: true,
    },
    {
      id: "contactNumber",
      name: "Contact Number",
      selector: (r) => r.contactNumber,
      sortable: true,
      width: "170px",
    },
    {
      id: "licenseStartDate",
      name: "License Start Date",
      selector: (r) => r.licenseStartDate,
      sortable: true,
      width: "170px",
    },
    {
      id: "licenseEndDate",
      name: "License End Date",
      selector: (r) => r.licenseEndDate,
      sortable: true,
      width: "170px",
    },
    
    // Toggle
    {
      id: "isActive",
      name: "IsActive",
      sortable: false,
      width: "110px",
      selector: (r) => r.isActive,
      cell: (row) => (
        <div
          className="form-check form-switch m-0"
          onClick={(e) => e.stopPropagation()}
          title={row.isActive ? "Active" : "Inactive"}
        >
          <input
            className="form-check-input"
            type="checkbox"
            role="switch"
            checked={!!row.isActive}
            onChange={() => {
              toggleStatus(row.id);
            }}
            aria-checked={!!row.isActive}
          />
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },

    // Actions
    {
      name: "Actions",
      sortable: false,
      width: "160px",
      cell: (row) => (
        <div
          className="d-flex align-items-center gap-2"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Edit */}
          <button
            type="button"
            className="btn btn-sm btn-outline-primary"
            title="Edit"
            aria-label="Edit"
            onClick={() => {
              getRowData(row, modeConstants.UPDATE_MODE);
              setShowModal(true);
            }}
          >
            <i className="bi bi-pencil"></i>
          </button>

          {/* View */}
          <button
            type="button"
            className="btn btn-sm btn-outline-success"
            title="View"
            aria-label="View"
            onClick={() => {
              getRowData(row, modeConstants.VIEW_MODE);
              setShowModal(true);
            }}
          >
            <i className="bi bi-eye"></i>
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const getRowData = (row, nextMode) => {
    dispatch(companyActions.getPlatformCompanyById(row.id));
    setMode(nextMode);
  };

  const toggleStatus = (id) => {
    dispatch(companyActions.deletePlatformCompanyById(id));
  };

  const onSort = (sortedColumn, sortDirection) => {
    sortingInProgressRef.current = true;
    const columnDirection = sortDirection
      ? sortDirection.toUpperCase() // "ASC" | "DESC"
      : null;
    setDefaultPage(gridState.pageNumber);
    setGridState((prevState) => ({
      ...prevState,
      orderBy:
        columnDirection !== null ? `${sortedColumn} ${columnDirection}` : "",
    }));
  };

  const onChangePage = (pageNumber) => {
    if (!sortingInProgressRef.current) {
      setGridState((prevState) => ({
        ...prevState,
        pageNumber: pageNumber,
      }));
    }
  };

  const onChangeRowsPerPage = (newPerPage, pageNumber) => {
    setGridState((prevState) => ({
      ...prevState,
      length: newPerPage,
      pageNumber: pageNumber,
    }));
  };

  const getAll = () => {
    dispatch(companyActions.getAllPlatformCompanies(gridState));
  };
  useEffect(() => {
    if (allData !== null) {
      setRowData(allData);
    }
    // eslint-disable-next-line
  }, [allData]);

  useEffect(() => {
    getAll();
    sortingInProgressRef.current = false;
    // eslint-disable-next-line
  }, [gridState]);

  return (
    <>
      <PlatformModal
        showModal={showModal}
        setShowModal={setShowModal}
        mode={mode}
      />
      <ActionsDataTable
        columns={columns}
        filterColumns={filterColumns}
        data={rowData.items}
        pagination
        highlightOnHover
        striped
        responsive
        persistTableHead
        selectableRows
        selectableRowsHighlight
        selectableRowsVisibleOnly
        setShowModal={setShowModal}
        paginationServer
        onSort={onSort}
        gridState={gridState}
        paginationTotalRows={rowData.total}
        onChangeRowsPerPage={onChangeRowsPerPage}
        onChangePage={onChangePage}
        paginationDefaultPage={defaultPage}
        paginationResetDefaultPage
        setMode={setMode}
        setGridState={setGridState}
        sortServer={true}
        allowToolbar = {false}
        allowSelection = {false}
      />
    </>
  );
}
